import { render, staticRenderFns } from "./EventManagementDetail.vue?vue&type=template&id=190a3b74&scoped=true&"
import script from "./EventManagementDetail.vue?vue&type=script&lang=js&"
export * from "./EventManagementDetail.vue?vue&type=script&lang=js&"
import style0 from "./EventManagementDetail.vue?vue&type=style&index=0&id=190a3b74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a3b74",
  null
  
)

export default component.exports